const stringLimiter = (str, limit = 10) => {
  if (str.length > limit) {
    return str.slice(0, limit) + " ...";
  } else {
    return str;
  }
};

export default stringLimiter;
